<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      :permanent="permanent"
      :temporary="!permanent"
      app>
      <v-list>

        <v-list-tile @click="permanent = !permanent">
          <v-list-tile-action>
            <v-icon v-html="permanent ? 'visibility_off' : 'visibility'" color="blue lighten-4"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="`Meniu ${permanent ? 'permanent' : 'temporar'}`"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <v-list-tile v-if="selectedProject" @click="download">
          <v-list-tile-action>
            <v-icon color="primary">cloud_download</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Descarca</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <v-subheader>Proiecte</v-subheader>
        <v-list-tile>
          <v-list-tile-content>
            <v-select
              :items="projects"
              item-text="title"
              item-value="id"
              v-model="selectedProject"
              auto
              label="Alege proiect"
              hide-details
              prepend-icon="map"
              single-line>
              <v-list-tile slot="no-data">
                <v-list-tile-action>
                    <v-avatar size="64px" tile>
                      <img src="@/assets/nope.jpg" alt="no projects, man...">
                    </v-avatar>
                  </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>&nbsp;Nu ai nici un proiect...</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="currentProject">
          <v-list-tile-content>
            <v-checkbox v-model="showProjectMarkers" on-icon="location_on" off-icon="location_off" :label="`Markere neatribuite (${noZoneMarkers})`"></v-checkbox>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="currentProject">
          <v-list-tile-content>
            <v-slider prepend-icon="group_work" hint="Zoom clustering" v-model="clusteringLevel" thumb-label :step="1" snap :min="0" :max="22"></v-slider>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="currentProject">
          <v-list-tile-content>
            <v-text-field label="Titlu" required :value="currentProject.title" @change="updateCurrentProjectTitle" prepend-icon="title"></v-text-field>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click.stop="addProjectDialog">
          <v-list-tile-action>
            <v-icon color="primary">add</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Proiect nou</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="selectedProject" @click="deleteProject">
          <v-list-tile-action>
            <v-icon color="error">delete</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Sterge proiectul curent</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-divider></v-divider>

        <template v-if="selectedProject">
          <v-subheader>Layere</v-subheader>
          <v-list-tile>
            <v-list-tile-content>
              <v-select
                :items="layers"
                item-text="title"
                item-value="id"
                v-model="selectedLayer"
                auto
                label="Alege layer"
                hide-details
                prepend-icon="format_shapes"
                single-line>
                <v-list-tile slot="no-data">
                  <v-list-tile-action>
                      <v-avatar size="64px" tile>
                        <img src="@/assets/nope.jpg" alt="no layers, man...">
                      </v-avatar>
                    </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>&nbsp;Nu ai nici un layer definit...</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-select>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="currentLayer">
            <v-list-tile-content>
              <v-text-field label="Titlu" required :value="currentLayer.title" @change="updateCurrentLayerTitle" prepend-icon="title"></v-text-field>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="currentLayer">
            <v-list-tile-action>
              <v-icon>color_lens</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <input type="color" :value="currentLayer.color" @change="updateCurrentLayerColor">
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="currentLayer">
            <v-list-tile-content>
              <v-checkbox v-model="currentLayer.edit" label="Mod editare layer"></v-checkbox>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="currentLayer">
            <v-list-tile-content>
              <v-checkbox v-model="currentLayer.drag" label="Mod miscare layer"></v-checkbox>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click.stop="addLayerDialog">
            <v-list-tile-action>
              <v-icon color="primary">add</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Layer nou</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="selectedLayer" @click="deleteLayer">
            <v-list-tile-action>
              <v-icon color="error">delete</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Sterge layer-ul curent</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <v-alert :value="currentLayer && currentLayer.coords.length < 3" type="info">
          Layer-ul selectat nu are definite coordonate. Click pe harta pentru a adauga 3 puncte.
        </v-alert>

        <v-divider></v-divider>

        <v-list-tile @click="computeLayerMarkers" v-if="layers && layers.length">
          <v-list-tile-content>
            <v-btn block color="primary">Atribuie markere</v-btn>
          </v-list-tile-content>
        </v-list-tile>

        <template v-if="layers">
          <v-divider></v-divider>
          <v-subheader>Vizibilitate</v-subheader>
          <v-list-tile v-for="layer in layers" :key="layer.id" @click.stop>
            <v-list-tile-action>
              <v-checkbox v-model="showMarkers" :value="layer.id" on-icon="location_on" off-icon="location_off"></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title :style="{'color': layer.color}" @click="selectedLayer = layer.id">
                {{layer.title}}
                ({{layer.markers.length}})
              </v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-checkbox v-model="chosenLayers" :value="layer.id" on-icon="layers" off-icon="layers_clear"></v-checkbox>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-list>

    </v-navigation-drawer>
    <v-toolbar app dark dense>
      <v-toolbar-side-icon @click.stop="drawer = !drawer" :disabled="permanent" v-if="!permanent"></v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="openInfo">
        <v-icon>info</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-progress-circular
        v-show="loading"
        color="white"
        height="2"
        :indeterminate="true"
      ></v-progress-circular>
    </v-toolbar>
    <v-content>
      <router-view/>
      <v-dialog v-model="dialog.addProject" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Proiect nou</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeProjectDialog">
              <v-icon color="error">clear</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <form ref="projectForm">
            <v-container grid-list-md>
              <v-layout column>
                <v-flex xs12>
                  <input type="file" ref="projectFile" @change="xlsxAdded" class="mb-4">
                </v-flex>
                <v-flex xs12>
                  <v-text-field label="Titlu" required v-model="newProject.title" v-if="newProject.sheets.length"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="newProject.selectedSheetMarkers" label="Sheet Markere" v-if="newProject.sheets.length">
                    <v-radio
                      v-for="sheet in newProject.sheets"
                      :key="sheet"
                      :label="sheet"
                      :value="sheet">
                    </v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-radio-group v-model="newProject.selectedSheetLayers" label="Sheet Layere (daca e cazul)" v-if="newProject.sheets.length">
                    <v-radio
                      v-for="sheet in newProject.sheets"
                      :key="sheet"
                      :label="sheet"
                      :value="sheet">
                    </v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="closeProjectDialog">Renunta</v-btn>
            <v-btn color="blue darken-1" flat @click.native="saveProject" :disabled="!newProject.selectedSheetMarkers || !newProject.title">Salveaza</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog.addLayer" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">Layer nou</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeLayerDialog">
              <v-icon color="error">clear</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <form ref="layerForm">
            <v-container grid-list-md>
              <v-layout column>
                <v-flex xs12>
                  <v-text-field label="Titlu" required v-model="newLayer.title"></v-text-field>
                </v-flex>
                <v-flex xs12 align-center>
                  <label>
                    Culoare:
                    <input type="color" v-model="newLayer.color">
                  </label>
                </v-flex>
              </v-layout>
            </v-container>
            </form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="closeLayerDialog">Renunta</v-btn>
            <v-btn color="blue darken-1" flat @click.native="saveLayer" :disabled="!newLayer.title || !newLayer.color">Salveaza</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="infoDialog" persistent max-width="500px">
        <v-card>
          <v-card-title>
            <span class="headline">App info</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="infoDialog = false">
              <v-icon color="error">clear</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            Coloane necesare in XLSX (scrise fix asa, nu conteaza ordinea):
            <ul>
              <li>Nr. crt.</li>
              <li>id</li>
              <li>lat</li>
              <li>lng</li>
              <li>layer (initial goala, se va completa de catre app)</li>
              <li>zona (initial goala, se va completa de catre app)</li>
            </ul>
            <a :href="`${SERVER_URL}/template.xlsx`" download>Template</a>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-snackbar
        :value="snack.open"
        :right="true"
        :timeout="60000"
        :top="true"
        :color="snack.type">
        {{ snack.message }}
        <v-btn
          color="white"
          flat
          @click="closeSnack">
          Close
        </v-btn>
      </v-snackbar>
    </v-content>
    <v-footer app>
      <span>&copy; 2018</span>
    </v-footer>
  </v-app>
</template>

<script>
import XLSX from 'xlsx'
import cloneDeep from 'lodash.clonedeep'
import {gmapApi} from 'vue2-google-maps'
import colors from 'vuetify/es5/util/colors'

const SERVER_URL = process.env.NODE_ENV === 'production' ? 'https://newlayers.verdedata.ro' : 'http://localhost:3535'

export default {
  name: 'App',
  data () {
    return {
      SERVER_URL: SERVER_URL,
      infoDialog: false,
      permanent: true,
      drawer: true,
      title: 'Map Layers',
      dialog: {
        addProject: false,
        addLayer: false
      },
      newProject: {
        title: null,
        data: null,
        sheets: [],
        selectedSheetMarkers: null,
        selectedSheetLayers: null,
        clusteringLevel: 15,
        showMarkers: true,
        markersData: null,
        layersData: null
      },
      newLayer: {
        title: null,
        color: '#00ff00',
        selected: false
      },
      chosenLayers: [],
      showMarkers: [],
      showProjectMarkers: true
    }
  },
  watch: {
    showProjectMarkers (value) {
      this.$store.commit('setShowProjectMarkers', value)
    },
    chosenLayers: {
      deep: true,
      handler (v) {
        this.$store.commit('setChosenLayers', v)
      }
    },
    showMarkers: {
      deep: true,
      handler (v) {
        this.$store.commit('setShowLayerMarkers', v)
      }
    },
    currentProject: {
      deep: true,
      handler (newProject, oldProject) {
        if (newProject) {
          this.showProjectMarkers = newProject.showMarkers
          if (!oldProject || newProject.id !== oldProject.id) {
            this.chosenLayers = newProject.layers.map(layer => layer.selected ? layer.id : null).filter(id => id)
            this.showMarkers = newProject.layers.map(layer => layer.showMarkers ? layer.id : null).filter(id => id)
          }
        }
      }
    },
    currentLayer (newLayer, oldLayer) {
      if (newLayer && newLayer.id && !this.chosenLayers.includes(newLayer.id) && newLayer.selected) {
        this.chosenLayers.push(newLayer.id)
      }
      if (newLayer && newLayer.id && newLayer.showMarkers && !this.showMarkers.includes(newLayer.id)) {
        this.showMarkers.push(newLayer.id)
      }
    }
  },
  computed: {
    google: gmapApi,
    clusteringLevel: {
      get () {
        return this.currentProject ? this.currentProject.clusteringLevel : 15
      },
      set (value) {
        this.$store.commit('setClusteringLevel', value)
      }
    },
    snack () {
      return this.$store.getters.snack
    },
    loading () {
      return this.$store.getters.loading
    },
    projects () {
      return this.$store.getters.projects
    },
    layers () {
      return this.$store.getters.layers
    },
    currentLayer () {
      return this.$store.getters.currentLayer
    },
    currentProject () {
      return this.$store.getters.currentProject
    },
    selectedProject: {
      get () {
        return this.$store.getters.selectedProject
      },
      set (v) {
        this.$store.dispatch('setSelectedProject', v)
      }
    },
    selectedLayer: {
      get () {
        return this.$store.getters.selectedLayer
      },
      set (v) {
        this.$store.dispatch('setSelectedLayer', v)
      }
    },
    noZoneMarkers () {
      if (this.currentProject) {
        return this.currentProject.markers.filter(marker => !marker.zona && !marker.layer).length
      }
      return 0
    }
  },
  methods: {
    openInfo () {
      this.infoDialog = true
    },
    download () {
      const filename = this.currentProject.title
      const wb = {SheetNames: [], Sheets: {}}

      const data1 = this.currentProject.markers.map(marker => {
        let newMarker = {}
        this.currentProject.headers.forEach(header => {
          newMarker[header] = marker[header]
        })

        return newMarker
      })

      const ws1 = XLSX.utils.json_to_sheet(data1) // , {header: this.currentProject.headers})

      wb.SheetNames.push('Markers')
      wb.Sheets['Markers'] = ws1

      const data2 = this.currentProject.layers.map(layer => {
        let newLayer = {
          id: layer.id,
          title: layer.title,
          color: layer.color
        }

        newLayer['markers'] = layer.markers.reduce((accumulator, marker) => {
          accumulator += `${marker};;;;;`

          return accumulator
        }, '')

        newLayer['latlng'] = this.google.maps.geometry.encoding.encodePath(layer.coords)

        return newLayer
      })
      const ws2 = XLSX.utils.json_to_sheet(data2)
      wb.SheetNames.push('Layers')
      wb.Sheets['Layers'] = ws2

      XLSX.writeFile(wb, filename)
    },
    computeLayerMarkers () {
      this.$store.commit('computeLayerMarkers', {google: this.google})
    },
    updateCurrentProjectTitle (value) {
      this.$store.commit('changeCurrentProjectTitle', value)
    },
    updateCurrentLayerTitle (value) {
      this.$store.commit('changeCurrentLayerTitle', value)
    },
    updateCurrentLayerColor (event) {
      console.log(event)
      this.$store.dispatch('changeCurrentLayerColor', event.target.value)
    },
    closeSnack () {
      this.$store.commit('setSnack', {message: null, type: 'error', open: false})
    },
    closeProjectDialog () {
      this.$set(this.dialog, 'addProject', false)
      this.$refs.projectForm.reset()
      this.$set(this.newProject, 'title', null)
      this.$set(this.newProject, 'data', null)
      this.$set(this.newProject, 'markersData', null)
      this.$set(this.newProject, 'layersData', null)
      this.$set(this.newProject, 'sheets', [])
      this.$set(this.newProject, 'selectedSheetMarkers', null)
      this.$set(this.newProject, 'selectedSheetLayers', null)
      this.$set(this.newProject, 'clusteringLevel', 15)
      this.$set(this.newProject, 'showMarkers', true)
    },
    closeLayerDialog () {
      this.$set(this.dialog, 'addLayer', false)
      this.$set(this.newLayer, 'title', null)
      this.$set(this.newLayer, 'color', '#ffffff')
      this.$set(this.newLayer, 'selected', false)
    },
    saveProject () {
      const markers = XLSX.utils.sheet_to_json(this.newProject.data.Sheets[this.newProject.selectedSheetMarkers], {header: 1, blankrows: false, defval: null, raw: true})
      const layers = XLSX.utils.sheet_to_json(this.newProject.data.Sheets[this.newProject.selectedSheetLayers], {header: 1, blankrows: false, defval: null, raw: true})
      this.$set(this.newProject, 'markersData', markers)
      this.$set(this.newProject, 'layersData', layers)
      this.$store.dispatch('addNewProject', {data: cloneDeep(this.newProject), google: this.google})
      this.$nextTick(() => this.closeProjectDialog())
    },
    saveLayer () {
      const layer = cloneDeep(this.newLayer)
      layer.selected = true
      layer.showMarkers = true
      layer.edit = true
      layer.drag = true
      this.$store.dispatch('addNewLayer', layer)
      this.$nextTick(() => this.closeLayerDialog())
    },
    addProjectDialog () {
      this.$set(this.dialog, 'addProject', true)
    },
    addLayerDialog () {
      const colorNames = Object.keys(colors)
      const colorIndex = Math.floor(Math.random() * colorNames.length)
      const colorShades = Object.keys(colors[colorNames[colorIndex]])
      const colorHexIndex = Math.floor(Math.random() * colorShades.length)
      this.$set(this.dialog, 'addLayer', true)
      this.$set(this.newLayer, 'title', `Layer ${this.currentProject.layers.length + 1}`)
      this.$set(this.newLayer, 'color', colors[colorNames[colorIndex]][colorShades[colorHexIndex]])
      console.log(colorNames[colorIndex], colorShades[colorHexIndex])
    },
    xlsxAdded (event) {
      const file = event.target.files[0]
      if (file && file.name && !this.newProject.title) {
        this.$set(this.newProject, 'title', file.name)
      }

      try {
        let fileReader = new FileReader()
        /* eslint-disable handle-callback-err */
        fileReader.onload = event => {
          const file = event.target.result
          const workbook = XLSX.read(file, {type: 'array'})
          this.$set(this.newProject, 'sheets', workbook.SheetNames)
          this.$set(this.newProject, 'data', workbook)
        }
        fileReader.readAsArrayBuffer(file)
      } catch (err) {
        alert('Dispozitivul d-voastra nu suporta aceasta functie.')
      }
    },
    deleteProject () {
      if (window.confirm('Sigur vrei sa stergi proiectul?')) {
        this.$store.dispatch('deleteProject')
      }
    },
    deleteLayer () {
      if (window.confirm('Sigur vrei sa stergi layer-ul?')) {
        this.$store.dispatch('deleteLayer')
      }
    }
  }
}
</script>
